import React, { Component } from 'react'
import './Footer.scss'

export default class Footer extends Component {
    render() {
        return (
            <div className="footer">
            <div className="container">
                <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center">
                        <p>© Copyright<h5><strong>Alexandre Provost</strong></h5></p>
                    </div>
                </div>
            </div>
        </div>
    
        )
    }
}

